import React from "react";
import "./style.css"
import logo from "../assets/img/thomaspironresize.jpg"
import webicon from "../assets/img/webiconred.png"
import fb from "../assets/img/fbred.png"

export default function Frame() {

    return (
        <div className="frame" style={{zIndex: "100", position: "absolute", width:'300px', padding: '10px', bottom: "5%", right: "1%"}}>
            <div>
            <img width="100px" alt="logo-thomaspiron" src={logo}/>
            </div>
            <a href="https://www.thomas-piron.eu/" target="_blank"><img width="50px" src={webicon}/></a>
            <a href="https://fr-fr.facebook.com/thomasetpiron" target="_blank"><img width="50px" src={fb}/></a>
        </div>
    )
}
